export enum SiteWeightUnit {
  KILOGRAM = "KILOGRAM",
  TONNE = "TONNE",
  POUND = "POUND",
  TON = "TON"
}
